import { cn } from "@lib/cn"
import { useTranslation } from "react-i18next"

import { LOCALES, LOCALE_LABELS, type Locale } from "@/i18n/config"

export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n, t } = useTranslation("common")
  return (
    <label className={cn("text-ink-muted inline-flex items-center gap-2 text-sm", className)}>
      <span className="sr-only md:not-sr-only">{t("language.label")}</span>
      <select
        value={i18n.language}
        onChange={(e) => void i18n.changeLanguage(e.target.value as Locale)}
        aria-label={t("language.label")}
        className="rounded-control border-border bg-surface text-ink min-h-11 border px-2 text-base md:min-h-9 md:text-sm"
      >
        {LOCALES.map((l) => (
          <option key={l} value={l}>
            {LOCALE_LABELS[l]}
          </option>
        ))}
      </select>
    </label>
  )
}
